import { ExponentialBackoff, Websocket, WebsocketBuilder } from 'websocket-ts';

import { getConfig } from './config';

let ostroWS: Websocket;

// Retry connection after 2s, 4s, 8s, 16s, 32s, 64s, 128s, 256s, 512s, 1024s, 2048s
const DELAY_BASE_MILLIS = 1000;
const DELAY_MAX_EXPONENT = 11;

export function getOstroWS() {
  if (!ostroWS) {
    const url = getConfig('WEB_SOCKET_URL');

    // The exponential backoff is calculated as DELAY_BASE_MILLIS * (2 ^ retryNumber) until retryNumber equals DELAY_MAX_EXPONENT
    // FTR https://github.com/jjxxs/websocket-ts/blob/c2644fce6642d820637bb892a1475ed4135bd676/src/backoff/exponentialbackoff.ts#L62
    ostroWS = new WebsocketBuilder(url)
      .withBackoff(new ExponentialBackoff(DELAY_BASE_MILLIS, DELAY_MAX_EXPONENT))
      .build();
  }

  return ostroWS;
}
